module.exports = __webpack_public_path__ + "housingStatic/img/demo.f217835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park_bg/demo.jpg
// module id = JwLh
// module chunks = 2